import styles from "./Button.module.scss";

export default function Button({ title, onClick, isDisabled }) {
  return (
    <button disabled={isDisabled} className={styles.button} onClick={onClick()}>
      {title}
    </button>
  );
}
